/* yargs/lib/is-promise */ function _(require, module, exports) {
    module.exports = function isPromise(maybePromise) {
        return maybePromise instanceof Promise;
    };
}
